"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFeather = require("react-feather");
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
var _loader = require("../loader");
var _FormContext = _interopRequireDefault(require("./FormContext"));
var _FormSelect = _interopRequireDefault(require("./FormSelect"));
var _Spinner, _CheckIcon;
const _excluded = ["selected", "onSave", "onFocus", "onBlur", "children", "readOnly"];
const FormEditableSelect = _ref => {
  let {
      selected,
      onSave,
      onFocus,
      onBlur,
      children,
      readOnly
    } = _ref,
    props = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  const {
    isFocus,
    onBlur: onInputBlur
  } = _react.default.useContext(_FormContext.default);
  const [saving, setSaving] = _react.default.useState(false);
  const [saved, setSaved] = _react.default.useState(false);
  const internalValueOptions = _react.default.useMemo(() => ({
    locked: isFocus
  }), [isFocus]);
  const [internalValue, setInternalValue] = (0, _arkReact.useInternalValueManager)(selected ?? undefined, internalValueOptions);
  const lastValue = (0, _arkReact.usePrevious)(selected ?? undefined);
  const savedHideTimeout = _react.default.useRef(null);

  // Unsubscribe to any event or async effect
  _react.default.useEffect(() => () => clearTimeout(savedHideTimeout?.current ?? undefined), [savedHideTimeout]);
  const handleSelectChange = _react.default.useCallback(async (newValue, event) => {
    let notifiedValue = lastValue;
    setInternalValue(newValue);
    if (newValue != lastValue && (0, _ark.isFunction)(onSave)) {
      setSaving(true);
      try {
        const savedValue = await onSave(newValue, event);
        if (savedValue !== undefined) {
          notifiedValue = savedValue;
          setSaved(true);
          savedHideTimeout.current = setTimeout(() => setSaved(false), 6000);
        }
      } catch {
        // Ignored
      }
      setSaving(false);
    }
    setInternalValue(notifiedValue);
    onInputBlur?.();
    onBlur?.(notifiedValue, event);
  }, [lastValue, onSave, onBlur, setInternalValue]);
  const handleInputFocus = _react.default.useCallback(() => {
    setSaved(false);
    if (savedHideTimeout.current !== null) {
      clearTimeout(savedHideTimeout.current);
      savedHideTimeout.current = null;
    }
    if ((0, _ark.isFunction)(onFocus)) onFocus();
  }, [savedHideTimeout, onFocus]);
  const icon = _react.default.useMemo(() => {
    if (saving) return _Spinner || (_Spinner = /*#__PURE__*/_react.default.createElement(_loader.Spinner, {
      className: "formEditableLoadingIcon"
    }));
    if (saved) return _CheckIcon || (_CheckIcon = /*#__PURE__*/_react.default.createElement(_reactFeather.Check, {
      className: "formEditableSavedIcon"
    }));
    return null;
  }, [saved, saving]);
  return /*#__PURE__*/_react.default.createElement(_FormSelect.default, (0, _extends2.default)({
    selected: internalValue,
    icon: icon,
    onChange: handleSelectChange,
    onFocus: handleInputFocus,
    readOnly: readOnly,
    managed: true
  }, props), children);
};
process.env.NODE_ENV !== "production" ? FormEditableSelect.propTypes = {
  id: _propTypes.default.string,
  selected: _propTypes.default.any,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  onSave: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func
} : void 0;
FormEditableSelect.defaultProps = {
  id: undefined,
  selected: undefined,
  className: undefined,
  children: undefined,
  onSave: undefined,
  onFocus: undefined,
  onBlur: undefined
};
var _default = exports.default = FormEditableSelect;